
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationIssueGrid extends Serenity.EntityGrid<CertificationIssueRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationIssue'; }
        protected getDialogType() { return CertificationIssueDialog; }
        protected getIdProperty() { return CertificationIssueRow.idProperty; }
        protected getInsertPermission() { return CertificationIssueRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationIssueRow.localTextPrefix; }
        protected getService() { return CertificationIssueService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) { 
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {

            let now = new Date();


            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[81].AutoPosting;

            var voucherNo = FormatHelper.GetVoucherNo(81);

            this.editItem(<CertificationIssueRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 81,
                TransDate: now.toDateString(),
                AutoPosting: autoposting

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}